import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InfoStatusEnum } from '../../../enums/infoStatus.enum'

@Component({
  selector: 'app-soc-addon-input',
  templateUrl: './soc-addon-input.component.html',
  styleUrls: ['./soc-addon-input.component.scss']
})
export class SocAddonInputComponent implements OnInit {

  @Input() label: string | null;
  @Input() alertLabel: string | null;
  @Input() addOn: string | null | undefined = "-";
  @Input() status: InfoStatusEnum | undefined = InfoStatusEnum.Info;
  @Input() input: any = "";
  @Input() placeholder: string = "";
  @Input() disabled: boolean = false;
  @Input() formControlName: string | null = null;
  @Input() form: any = null;
  @Output() inputChange = new EventEmitter<any>();

  public infoStatusEnum = InfoStatusEnum;
    
  constructor() { }

  ngOnInit(): void {
  }

}
